import React, { useCallback, useState, memo, useMemo } from 'react';
import CartImage from 'components/CartItemList/CartImage';
import { getV2PdfBaseUrl } from 'helpers/env';
export interface CartItemPreviewProps {
  projectId: string;
  projectVersion: number;
  flashId: string;
  fallbackThumbnail: string;
  children?: React.ReactElement;
  handleItemClick: () => void;
}

export const CartItemProjectPreview = memo(
  ({
    projectId,
    flashId,
    projectVersion,
    fallbackThumbnail,
    children,
    handleItemClick
  }: CartItemPreviewProps): JSX.Element => {
    const [thumbnailLoading, setThumbnailLoading] = useState(true);

    const onLoadCartImage = useCallback(() => {
      setThumbnailLoading(false);
    }, []);

    const productImgUrl = fallbackThumbnail;
    // this is hardcoded for now since the preload is unaware of what the future width requested will be
    const imageWidth = 100;
    let projectImgUrl: string | undefined = undefined;

    if (projectVersion) {
      projectImgUrl = `${getV2PdfBaseUrl()}/${flashId}/projects/${projectId}/preview?previewVersion=${projectVersion}&width=${imageWidth}`;
    }

    const cartImage = useMemo(
      () => (
        <CartImage
          projectImgUrl={projectImgUrl}
          productImgUrl={productImgUrl}
          alt=""
          onLoad={onLoadCartImage}
          thumbnailLoading={thumbnailLoading}
          handleItemClick={handleItemClick}
        >
          {children}
        </CartImage>
      ),
      // TODO: Refactor this dependency
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [projectImgUrl, productImgUrl, thumbnailLoading]
    );

    return cartImage;
  },
  (prevProps, nextProps) => {
    return (
      // Ignore the `children` prop
      prevProps.fallbackThumbnail === nextProps.fallbackThumbnail &&
      prevProps.flashId === nextProps.flashId &&
      prevProps.projectId === nextProps.projectId &&
      prevProps.projectVersion === nextProps.projectVersion
    );
  }
);
